import type { BeneficialOwnerResponse } from '@gcv/shared';
import { BeneficialOwnerUpdateAction } from '@gcv/shared';

export const isBeneficialOwnerSelected = (
  owner: BeneficialOwnerResponse,
  templateResultId: string,
  thresholdPercentage: number
): boolean => {
  const confirmation = owner.template_result_map[templateResultId]?.confirmed_owner;

  return (
    !owner.archived &&
    (confirmation === true ||
      (confirmation === undefined &&
        owner.ownership_in_this_business >= thresholdPercentage &&
        owner.last_update.update_action === BeneficialOwnerUpdateAction.Certify))
  );
};
